import React, { Component } from 'react';
import PropTypes from 'prop-types';
import JSONTree from 'react-json-tree';

class JSONModal extends Component {
  static displayName = 'JSONModal';

  static propTypes = {
    onClose: PropTypes.func.isRequired,
    urlData: PropTypes.object
  };

  render() {
    let { urlData } = this.props;
    return (
      <div>
        <JSONTree data={urlData} />
      </div>
    );
  }
}

export default JSONModal;
